import React from "react"

import AppProvider from "contexts/AppProvider"
import GameInforProvider from "contexts/GameInforProvider"
import ReactDOM from "react-dom"

import App from "./App"

ReactDOM.render(
    <React.StrictMode>
        <AppProvider>
            <GameInforProvider>
                <App />
            </GameInforProvider>
        </AppProvider>
    </React.StrictMode>,
    document.getElementById("root")
)
